import { useEffect, useState } from 'react'

export type Viewport = 'mobile' | 'tablet' | 'desktop'

function getViewport(w: number): Viewport {
  if (w < 640) return 'mobile'
  if (w < 1024) return 'tablet'
  return 'desktop'
}

export function useViewport(): Viewport {
  const [vp, setVp] = useState<Viewport>(() => getViewport(window.innerWidth))

  useEffect(() => {
    const onResize = () => setVp(getViewport(window.innerWidth))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return vp
}
